export default "__VITE_ASSET__a0dc8957__"